// Cores de marca de terceiros. Não são do tema (não mudam por tema) — mas
// devem ser nomeadas e centralizadas, nunca repetidas inline.
export const brandColors = {
  whatsapp: {
    main: '#25D366',     // verde oficial WhatsApp: track do toggle ON, botão enviar, bolha
    action: '#1FA855',   // verde de AÇÃO (mais escuro): botão "Ativar", checks, "Confirmar"
    bubble: '#d9fdd3',   // fundo do balão enviado no preview
    chatBg: '#ddd3c8',   // fundo do corpo do chat no preview
    header: '#075e54',   // header do chat (avatar/online) no preview
  },
};
